import { getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum ResourceUseIds {
  REGISTRATIONS = 1,
  RFQS = 2,
}

export function getResourceUses(): ISelectItem[] {
  return [
    { id: ResourceUseIds.REGISTRATIONS, label: 'Registrations' },
    { id: ResourceUseIds.RFQS, label: 'RFQs' },
  ]
}

export const getResourceUseById = getItemByIdFactory(getResourceUses)
